import { useState } from "react";

import iconAddGroup from "../assets/images/add-group-hover.svg";
import iconAddParticipant from "../assets/images/add-participant-hover.svg";
import iconGroup from "../assets/images/title-group.svg";
import iconSubscriptions from "../assets/images/title-subscription.svg";
import iconPersonalInfo from "../assets/images/title-personal-info.svg";
import iconPayment from "../assets/images/title-payment.svg";
import iconBilling from "../assets/images/title-billing.svg";
import avatar1 from "../assets/images/avatar2.png";
import UserMediaSettings from "../components/UserMediaSettings";

const Settings = () => {
  const [activeTab, setActiveTab] = useState("Groups");
  const [activeGroup, setActiveGroup] = useState("1");

  const tabs = [
    { name: "Groups", img: iconGroup },
    { name: "Subscriptions", img: iconSubscriptions },
    { name: "Paymens", img: iconPayment },
    { name: "Billing", img: iconBilling },
    { name: "Personal Info", img: iconPersonalInfo },
    { name: "Call Settings", img: iconPersonalInfo },
  ];

  const listGroups = [
    {
      id: 1,
      name: "Developers",
      users: [{ name: "Sawyer" }, { name: "Diego" }, { name: "Milo" }, { name: "Ronan" }],
    },
    {
      id: 2,
      name: "Graphic",
      users: [
        { name: "Sophia" },
        { name: "Emma" },
        { name: "Olivia" },
        { name: "Luna" },
        { name: "Gianna" },
        { name: "Avery" },
        { name: "Penelope" },
      ],
    },
    {
      id: 3,
      name: "Marketing",
      users: [
        { name: "Liam" },
        { name: "Henry" },
        { name: "Levi" },
        { name: "Liam" },
        { name: "Jackson" },
        { name: "Leo" },
        { name: "Adrian" },
        { name: "Robert" },
        { name: "Parker" },
        { name: "River" },
        { name: "Ryder" },
      ],
    },
  ];

  console.log(activeGroup, listGroups);

  return (
    <div className="settings-container">
      <div className="settings-tabs">
        {tabs.map((i) => {
          return (
            <div className={`settings-tabs-items ${activeTab === i.name && "active"} `} onClick={() => setActiveTab(i.name)}>
              <img src={i.img} width={35} />
              <span>{i.name}</span>
            </div>
          );
        })}
      </div>
      <div className="settings-tab-content">
        {activeTab === "Groups" && (
          <>
            <div className="settings-tab-sidebar">
              <ul>
                {listGroups.map((i, index) => {
                  return (
                    <li className={`settings-tab-list-groups ${activeGroup === i.id ? "active" : null}`} onClick={() => setActiveGroup(i.id)}>
                      {i.name} ({i.users.length})
                    </li>
                  );
                })}
              </ul>
              <div className="p-t-20 space-between">
                <img src={iconAddGroup} width={36} />
                <input placeholder="Group Name" />
              </div>
              <div className="p-t-10 flex-end">
                <span className="bold pointer"> Add Group </span>
              </div>
            </div>
            <div className="p-l-20 w-100p">
              <div className="p-b-10 m-l-20 flex">
                <img src={iconAddParticipant} width={36} className="m-r-10" />
                <input placeholder="johnsmith@gmail.com" />
                <div className="align-items-center m-l-20">
                  <span className="m-r-10 bold pointer"> Add </span>
                  <span className="bold pointer"> Cancel </span>
                </div>
              </div>

              <div className="settings-tab-list-users">
                {listGroups[activeGroup - 1].users.map((i) => {
                  return (
                    <ul>
                      <li className="username">
                        <img src={avatar1} width="32" className="m-r-10" />
                        {i.name}
                      </li>
                      <li className="email">{i.name}@gmail.com</li>
                      <li className="group">EC</li>
                      <li className="remove">✖</li>
                    </ul>
                  );
                })}
              </div>
            </div>
          </>
        )}
        {activeTab === "Call Settings" && (
          <>
            <h3>Call Settings</h3>
            <UserMediaSettings />
          </>
        )}
      </div>
    </div>
  );
};

export default Settings;
